import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthService } from './auth.service';
import { EntryComponent } from './entry/entry.component';
import { LoginComponent } from './login/login.component';
import { AccountPasswordComponent } from './account-password/account-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthActivateQuestionsService } from './auth-activate-questions.service';
import { ClientSelectorComponent } from './client-selector/client-selector.component';
import { KeplerMatchSelectorComponent } from './kepler-match-selector/kepler-match-selector.component';
import { MarsGroupSelectorComponent } from './mars-group-selector/mars-group-selector.component';
import { OtpComponent } from './otp/otp.component';

/**
 * Authentication module: groups the components and services for the login,
 * account activation and OTP verification flow.
 */
@NgModule({
  imports: [CommonModule, CoreModule, AuthRoutingModule],
  declarations: [
    EntryComponent,
    LoginComponent,
    AccountPasswordComponent,
    ForgotPasswordComponent,
    ClientSelectorComponent,
    KeplerMatchSelectorComponent,
    MarsGroupSelectorComponent,
    OtpComponent
  ],
  providers: [AuthService, AuthActivateQuestionsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AuthModule {}
